import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const BoxReturn = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { fillRule: "evenodd", d: "M10.292 1.485a1.25 1.25 0 0 1-.36 1.73L4.665 6.667h8.864l-1.143-.535a1.25 1.25 0 1 1 1.06-2.264l5.781 2.704q.137.065.25.155A.83.83 0 0 1 20 7.5v10.417c0 .46-.373.833-.833.833H.833A.833.833 0 0 1 0 17.917V7.5q0-.096.021-.187a1.25 1.25 0 0 1 .562-.96L8.56 1.125a1.25 1.25 0 0 1 1.73.36Zm-3.814 10.58a.833.833 0 0 0 0 1.147l2.5 2.639a.833.833 0 0 0 1.21-1.146l-1.167-1.233h3.896a.833.833 0 0 0 0-1.666H9.02l1.167-1.233a.833.833 0 0 0-1.21-1.146z" }) }));
});
BoxReturn.displayName = 'BoxReturn';
export default BoxReturn;
//# sourceMappingURL=BoxReturn.js.map